// @flow

/**
 * Injects a script with provided src to the head and
 * returns a Promise that will be resolved when the script
 * will be fully loaded.
 * @param  {string} src
 * @return {Promise}
 */
function injectScript(src: string): Promise<any> {
  return new Promise((resolve, reject) => {
    const script = document.createElement('script')
    script.async = true
    script.src = src
    script.addEventListener('load', resolve)
    script.addEventListener('error', () => {
      reject(new Error('Error loading script.'))
    })
    script.addEventListener('abort', () => {
      reject(new Error('Script loading aborted.'))
    })
    document.head && document.head.appendChild(script)
  })
}

export default injectScript
